<div class="modal-header">
  <h4 class="modal-title">Update your pet status</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <p>
    By pressing confirm, you are letting us know that your pet is no longer missing.
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger text-white" (click)="activeModal.dismiss()">
    Cancel
  </button>
  <button type="button" class="btn btn-success text-white" ngbAutofocus (click)="activeModal.close()">
    Confirm
  </button>
</div>
